import styled from 'styled-components';
import { font, button } from '../../lib/sharedStyles';

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  gap: 12px;
`;

export const CampaignMessaging = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-bottom: 16px;
`;

export const WrapperContainer = styled.div`
  width: 100%;
  min-width: 200px;
  position: relative;
  margin: auto;
`;

const inputStyles = `
  width: 100%;
  padding: 16px 10px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  background: transparent;
  ${font('Instrument Sans', 400, '14px', '22px')}
  outline: none;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

export const FloatingLabel = styled.label<{ isFloating: boolean }>`
  position: absolute;
  top: ${({ isFloating }) => (isFloating ? '5px' : '50%')};
  left: 10px;
  transform: translateY(-50%);
  color: ${({ isFloating }) => (isFloating ? '#666' : '#aaa')};
  ${font('Instrument Sans', 400, '14px', '22px')}
  pointer-events: none;
  transition: 0.2s ease all;
  padding: 0 2px;
  background: #fff;
  z-index: 1;
`;

export const StyledInput = styled.input`
  ${inputStyles}
`;

export const StyledSelect = styled.select`
  ${inputStyles}
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url('data:image/svg+xml;utf8,<svg fill="%23666" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>')
    no-repeat right 10px center;
  background-size: 16px;
`;

export const StyledOption = styled.option`
  padding: 8px;
`;

export const TextArea = styled.textarea`
  height: 128px;
  box-sizing: border-box;
  ${inputStyles}
  padding: 19px 16px;
  background: #fff;
`;

export const NameFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  @media (min-width: 768px) {
    align-items: center;
  }
`;

export const CheckboxLabel = styled.label`
  ${font('Instrument Sans', 400, '12px', '18px')}
  margin: 0;
`;

export const ErrorText = styled.span`
  font-size: 12px;
  margin-top: 4px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const StyledButton = styled.button`
  ${button('Black Pill', 'fender')}
`;